import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';

import { AppNavigationUnifiedQuery } from './AppNavigationUnifiedQuery.graphql';

export function preloadAppNavigation() {
	return waitForAllReturnWhenError([
		query({
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query: AppNavigationUnifiedQuery,
		}),
		preloadWebItemLocation({
			location: 'system.header/left',
		}),
	]);
}
